module.exports = __webpack_public_path__ + "static/img/stay-option-icon-spa.b1385429.svg";